import { createReducer, on } from '@ngrx/store';
import { MedicationScheme } from 'vidis-common/medication';
import { GeneralError } from 'vidis-common';

import * as MedicationActions from '../actions/medication.action';

export interface State {
    medicationSchemes: MedicationScheme[];
    medicationErrors: GeneralError[];
    medicationSchemeLoading: boolean;
    isLoaded: boolean
}

const initialState: State = {
    medicationSchemes: undefined,
    medicationErrors: undefined,
    medicationSchemeLoading: true,
    isLoaded: false
};

export const medicationReducer = createReducer(
    initialState,
    on(MedicationActions.setMedicationAction, (state, {medicationSchemes}) => ({
            ...state,
            medicationSchemes,
            medicationSchemeLoading: false,
            isLoaded: true
        })
    ),
    on(MedicationActions.setMedicationErrorAction, (state, {medicationErrors}) => ({
        ...state,
        medicationErrors,
        medicationSchemeLoading: false
    })),
    on(MedicationActions.clearMedicationErrorAction, state => ({
        ...state,
        medicationErrors: undefined
    })),
    on(MedicationActions.clearMedicationAction, () => (initialState))
);
